import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat.js';

import { DEFAULT_LOCALE } from './constants';
// Bundled locales ('en' is dayjs's built-in default, used for en-US).
import 'dayjs/locale/de.js';
import 'dayjs/locale/en-gb.js';
import 'dayjs/locale/es.js';
import 'dayjs/locale/it.js';
import 'dayjs/locale/pl.js';
import 'dayjs/locale/ro.js';
import 'dayjs/locale/sr.js';

// Enables the localized format tokens (`ll`, `LT`, …) and pins the global default locale, so
// dates are deterministic in tests/SSR. The app overrides it from the browser at startup via
// setDateLocale(). Imported for its side effects wherever the format* helpers are used.
dayjs.extend(localizedFormat);
dayjs.locale(DEFAULT_LOCALE.toLowerCase());
